// Gestionnaire d'erreurs centralisé
export class ErrorHandler {
  static handle(error, context = '') {
    console.error(`[${context}] Erreur:`, error);
    
    // Types d'erreurs courantes
    const errorTypes = {
      NETWORK_ERROR: 'Erreur de connexion',
      AUTH_ERROR: 'Erreur d\'authentification',
      PERMISSION_ERROR: 'Permissions insuffisantes',
      VALIDATION_ERROR: 'Données invalides',
      UNKNOWN_ERROR: 'Une erreur inattendue s\'est produite'
    };

    let errorMessage = errorTypes.UNKNOWN_ERROR;
    let errorCode = 'UNKNOWN_ERROR';

    // Classification des erreurs
    if (error.code === 'auth/user-not-found') {
      errorMessage = 'Identifiant ou mot de passe incorrect';
      errorCode = 'USER_NOT_FOUND';
    } else if (error.code === 'auth/wrong-password') {
      errorMessage = 'Identifiant ou mot de passe incorrect';
      errorCode = 'WRONG_PASSWORD';
    } else if (error.code === 'auth/invalid-credential') {
      errorMessage = 'Identifiant ou mot de passe incorrect';
      errorCode = 'INVALID_CREDENTIAL';
    } else if (error.code === 'auth/invalid-email') {
      errorMessage = 'Format d\'email invalide';
      errorCode = 'INVALID_EMAIL';
    } else if (error.code === 'auth/user-disabled') {
      errorMessage = 'Ce compte a été désactivé';
      errorCode = 'USER_DISABLED';
    } else if (error.code === 'auth/too-many-requests') {
      errorMessage = 'Trop de tentatives de connexion. Veuillez réessayer plus tard';
      errorCode = 'TOO_MANY_REQUESTS';
    } else if (error.message?.includes('Failed to fetch')) {
      errorMessage = 'Problème de connexion au serveur';
      errorCode = 'NETWORK_ERROR';
    } else if (error.message?.includes('permission')) {
      errorMessage = 'Permissions insuffisantes';
      errorCode = 'PERMISSION_ERROR';
    } else if (error.message) {
      errorMessage = error.message;
    }

    return {
      message: errorMessage,
      code: errorCode,
      originalError: error,
      context
    };
  }

  static showToast(error, toastFunction) {
    if (toastFunction) {
      toastFunction(error.message, 'error');
    } else {
      // Fallback si pas de système de toast
      alert(error.message);
    }
  }

  static logError(error, context = '') {
    // En production, vous pourriez envoyer les erreurs à un service comme Sentry
    if (process.env.NODE_ENV === 'production') {
      // Service de logging en production
      console.log('Logging error to external service:', { error, context });
    } else {
      console.error(`[${context}] Development error:`, error);
    }
  }
}

// Hook pour la gestion d'erreurs dans les composants React
export const useErrorHandler = () => {
  const handleError = (error, context = '') => {
    const processedError = ErrorHandler.handle(error, context);
    ErrorHandler.logError(processedError, context);
    return processedError;
  };

  const showError = (error, toastFunction) => {
    ErrorHandler.showToast(error, toastFunction);
  };

  return { handleError, showError };
};
